import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { auth } from '../config/firebase';

// Plain-language messages for the Firebase errors users can actually hit.
// Raw Firebase messages (e.g. "Firebase: Error (auth/...)") are never shown.
const AUTH_ERROR_MESSAGES = {
  'auth/invalid-phone-number': 'This mobile number does not look right. Please check the country code and number.',
  'auth/missing-phone-number': 'Please enter your mobile number.',
  'auth/operation-not-allowed': 'We cannot send an OTP to this number. Please check the country code and number.',
  'auth/network-request-failed': 'We could not reach the server. Please check your internet connection and try again. If it still does not work, refresh the page and fill in the form again.',
  'auth/too-many-requests': 'Too many attempts. Please wait a few minutes and try again.',
  'auth/quota-exceeded': 'We are unable to send OTPs right now. Please try again later.',
  'auth/captcha-check-failed': 'Verification failed. Please refresh the page and try again.',
  'auth/invalid-verification-code': 'Invalid OTP. Please try again.',
  'auth/code-expired': 'This OTP has expired. Please use Resend OTP to get a new one.'
};

const getAuthErrorMessage = (error, fallback) => AUTH_ERROR_MESSAGES[error?.code] || fallback;

// The element the current verifier was created on
let verifierContainer = null;

export const setupRecaptcha = (containerId) => {
  const container = document.getElementById(containerId);
  if (window.recaptchaVerifier && verifierContainer === container) return;

  // The form remounts with a new container element when the user switches events,
  // so a verifier bound to the old element has to be replaced.
  if (window.recaptchaVerifier) {
    try {
      window.recaptchaVerifier.clear();
    } catch (error) {
      console.error('reCAPTCHA clear error:', error);
    }
  }

  verifierContainer = container;
  window.recaptchaVerifier = new RecaptchaVerifier(auth, container, {
    size: 'invisible',
    callback: () => {
      // console.log('reCAPTCHA solved');
    },
    'error-callback': (error) => {
      console.error('reCAPTCHA error:', error);
    }
  });
};

export const sendOTP = async (phoneNumber) => {
  try {
    setupRecaptcha('recaptcha-container');

    const appVerifier = window.recaptchaVerifier;
    const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
    return { success: true, confirmationResult };
  } catch (error) {
    console.error('OTP Send Error:', error);
    // Keep the verifier: Firebase resets it after a failed send so it can be reused.
    // Clearing it leaves the widget in the container, and the next attempt then fails
    // with "reCAPTCHA has already been rendered in this element".
    return { success: false, error: getAuthErrorMessage(error, 'Failed to send OTP. Please try again.') };
  }
};

export const verifyOTP = async (confirmationResult, otp) => {
  try {
    const result = await confirmationResult.confirm(otp);
    return { success: true, user: result.user };
  } catch (error) {
    console.error('OTP Verify Error:', error);
    return { success: false, error: getAuthErrorMessage(error, 'Could not verify the OTP. Please try again.') };
  }
};
